import {gql} from '@apollo/client';

export const SUBMIT_COMPLAINT_APPEAL = gql`
    mutation SubmitCustomerComplaintAppeal(
        $complaintId: Long!,
        $appealReason: String!,
        $appealAttachmentS3KeysJson: String
    ) {
        submitCustomerComplaintAppeal(
            complaintId: $complaintId,
            appealReason: $appealReason,
            appealAttachmentS3KeysJson: $appealAttachmentS3KeysJson
        )
    }
`;

export interface SubmitComplaintAppealResponse {
    submitCustomerComplaintAppeal: number;
}

export interface SubmitComplaintAppealVariables {
    complaintId: number;
    appealReason: string;
    appealAttachmentS3KeysJson?: string;
}

export const ACKNOWLEDGE_COMPLAINT = gql`
    mutation AcknowledgeCustomerComplaint($complaintId: Long!) {
        acknowledgeCustomerComplaint(complaintId: $complaintId)
    }
`;

export interface AcknowledgeComplaintResponse {
    acknowledgeCustomerComplaint: boolean;
}

export interface AcknowledgeComplaintVariables {
    complaintId: number;
}

export const ABANDON_COMPLAINT_APPEAL = gql`
    mutation AbandonCustomerComplaintAppeal($complaintId: Long!) {
        abandonCustomerComplaintAppeal(complaintId: $complaintId)
    }
`;

export interface AbandonComplaintAppealResponse {
    abandonCustomerComplaintAppeal: boolean;
}

export interface AbandonComplaintAppealVariables {
    complaintId: number;
}
